import { MapWorkspacePermissionType } from 'src/app/shared/map-data-services/mapWorkspace/map-workspace-permission';

export enum MapMenuCode {
    LAYERS = 'layers',
    LEGACY_TASKS = 'legacyTasks',
    TASKS = 'tasks',
    ADD_TO_TASK = 'addToTask',
    FILTERS = 'filters',
    SURVEY_JOBS = 'surveyJobs'
}

export class MapMenuItem {
    id: number;
    name: string;
    iconClass: string;
    modusIcon?: string;
    state?: string;
    menuCode: MapMenuCode;
    selected: boolean;
    highlight: boolean;
    displayName: string;
    group: number;
    visibleMode?: MapWorkspacePermissionType;
    menuClass?: string;
}

export const mapMenuList: MapMenuItem[] = [
    {
        id: 1,
        name: 'Layer',
        iconClass: 'icon_line_layers',
        state: 'mapViewer/mainmenu/layers',
        menuCode: MapMenuCode.LAYERS,
        selected: false,
        highlight: false,
        displayName: 'TC.Common.Lower_Layers',
        group: 1
    },
    {
        id: 2,
        name: 'Task',
        iconClass: 'icon_solid_todo',
        state: 'mapViewer.tasks',
        menuCode: MapMenuCode.LEGACY_TASKS,
        selected: false,
        highlight: false,
        displayName: 'TC.Todos',
        group: 1,
        visibleMode: MapWorkspacePermissionType.FULL_ACCESS
    },
    {
        id: 3,
        name: 'Filter',
        iconClass: 'icon_solid_filter',
        menuClass: 'filter-menu',
        menuCode: MapMenuCode.FILTERS,
        selected: false,
        highlight: false,
        displayName: 'TC.Common.MapFilters',
        group: 2
    },
    {
        id: 4,
        name: 'Task',
        iconClass: 'icon_solid_todo',
        state: 'mapViewer.tasks',
        menuCode: MapMenuCode.TASKS,
        selected: false,
        highlight: false,
        displayName: 'TC.Common.Tasks',
        group: 1,
        visibleMode: MapWorkspacePermissionType.FULL_ACCESS
    },
    {
        id: 5,
        name: 'Survey Jobs',
        iconClass: 'modus-icons',
        modusIcon: 'device_tsc7',
        state: 'surveyViewer.jobs',
        menuCode: MapMenuCode.SURVEY_JOBS,
        selected: false,
        highlight: false,
        displayName: 'Survey.SurveyJobPanel.Jobs',
        group: 1,
        visibleMode: MapWorkspacePermissionType.FULL_ACCESS
    }
];
